













import Vue from "vue";

export type InvestmentOptionPanelType = {
  id: string;
  projectId: number;
  numberOfStocks: number;
  amount: number;
}

export default Vue.extend({
  props: {
    investmentOptionPanel: {
      type: Object as Vue.PropType<InvestmentOptionPanelType>,
      required: true,
    },
    addableNumberOfStocks: {
      type: Number,
      required: true
    },
    addNumberOfStoks: {
      type: Function,
      required: true
    }
  },
  computed: {
    disabled(): boolean  {
      if (this.investable) {
        return false
      }
      return true
    },
    investable(): boolean {
      return this.addableNumberOfStocks >= this.investmentOptionPanel.numberOfStocks
    }
  },
});
